export const dealershipSortOptions = [
  { id: 1, name: 'Dealership ID' },
  { id: 2, name: 'Dealership Name' },
];

export const bottomSheetMenuList = [{ name: 'Remove' }];
